export enum EServiceChangeRequestSection {
  OVERVIEW = 'OVERVIEW',
  FORM = 'FORM',
  PRICING = 'PRICING',
  WORKFLOW = 'WORKFLOW',
  OFFICER_FORM = 'OFFICER_FORM',
  TRANSLATION = 'TRANSLATION',
  _UNKOWN_ = '_UNKOWN_',
}
